import {
  ApprovalModel,
  ApprovalTypeEnum,
  Approver,
  Level,
  ModelTypeEnum,
} from "~/application/types";
import { groupBy } from "~/utils/object.utils";
import { ApprovalTypeSchema, ModelTypeSchema } from "./types";

export const EMPTY_LEVEL = {
  approvers: [] as Approver[],
} as Level;

export type EditableApprovalModel = {
  uuid?: string;
  name: string;
  isAllBranches: boolean;
  approvalType?: ApprovalTypeEnum;
  modelTypes?: ModelTypeEnum[];
  markAllCostCenters: boolean;
  markAllProjects: boolean;
  markAllPhases: boolean;
  markAllGroups: boolean;
  markAllGroupApprovers: boolean;
  branchName?: {
    uuid?: string;
    name?: string;
  };
  costCenters: {
    uuid: string;
    name: string;
    isActive?: boolean;
  }[];
  projects: {
    uuid: string;
    name: string;
    isActive?: boolean;
  }[];
  phases: {
    uuid: string;
    name: string;
    isActive?: boolean;
  }[];
  groups: {
    uuid: string;
    description: string;
    isActive?: boolean;
  }[];
  groupApprovers: {
    uuid: string;
    description: string;
    isActive?: boolean;
  }[];
  applyExpense: boolean;
  outPolicyApprovalModel?: { uuid: string; name: string };
  levels: Level[];
};

interface GetDefaultValuesProps {
  isNew?: boolean;
  defaultData: ApprovalModel;
}

export function getDefaultValues({
  isNew,
  defaultData,
}: GetDefaultValuesProps): EditableApprovalModel {
  const levels = Object.entries(groupBy(defaultData?.approvers ?? [], "level")).map(
    ([_, approvers]) => ({ approvers }),
  ) as Level[];

  const modelTypes = defaultData?.modelType ? [defaultData.modelType] : [ModelTypeEnum.TRAVEL];

  let defaultValues = {
    ...defaultData,
    markAllCostCenters: false,
    markAllProjects: false,
    levels,
    markAllPhases: false,
    markAllGroups: false,
    markAllGroupApprovers: false,
    modelTypes,
  };

  if (levels.length === 0) {
    defaultValues.levels = [EMPTY_LEVEL];
  }

  if (isNew) {
    defaultValues = {
      ...defaultValues,
      name: "",
      costCenters: [],
      approvalType: ApprovalTypeEnum.COST_CENTER,
      isAllBranches: true,
      applyExpense: true,
    };
  }

  if (defaultData?.branch?.name || defaultData?.branch?.uuid) {
    return {
      ...defaultValues,
      branchName: defaultData.branch,
    } as EditableApprovalModel;
  }

  return {
    ...defaultValues,
    branchName: undefined,
  } as EditableApprovalModel;
}

export const approvalTypeOptions = [
  {
    label: "Centro de custo",
    value: ApprovalTypeEnum.COST_CENTER,
  },
  {
    label: "Projeto",
    value: ApprovalTypeEnum.PROJECT,
  },
  {
    label: "Fase",
    value: ApprovalTypeEnum.PHASE,
  },
  {
    label: "Grupo",
    value: ApprovalTypeEnum.GROUP,
  },
] as ApprovalTypeSchema[];

export const modelTypeOptions = [
  {
    label: "Viagem",
    value: ModelTypeEnum.TRAVEL,
  },
  {
    label: "Adiantamento",
    value: ModelTypeEnum.ADVANCE,
  },
  {
    label: "Relatório de despesa",
    value: ModelTypeEnum.EXPENSE_REPORT,
  },
  {
    label: "Fora da política",
    value: ModelTypeEnum.BROKEN_POLICY,
  },
] as ModelTypeSchema[];
